import React, { useEffect, useState } from "react";
import {
  Paper,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
// import axios from "axios";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { toast } from "react-toastify";
import axiosInstance from "../../config/axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

const SmsConfiguration = () => {
  const [data, setData] = useState({});
  const [storeData, setStoreData] = useState([]);
  const superuserId = localStorage.getItem("is_superuser");
  const storeId = localStorage.getItem("store_id");
  const [uname, setUname] = useState("");
  const [password, setPassword] = useState("");
  const [sender, setSender] = useState("");
  const [url, setUrl] = useState("");
  const [tempid, setTempid] = useState("");
  const [route, setRoute] = useState("");
  const [msgtype, setMsgtype] = useState("");
  const [active, setActive] = useState("");
  const [sms, setSms] = useState("");

  const [selectStoreId, setSelectStoreId] = useState(null);
  const [rowData, setRowData] = useState({});
  const [ids, setIds] = useState(null);

  const [listSamStoreID, setListSamStoreID] = useState(1);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const transitionData = () => {
    axiosInstance
      .get(`api/admin/sms-configuration-store/?store_id=${storeId}`, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        console.log(
          "sms Data list===>",
          response?.data?.settingsmsconfiguration,
        );
        setData(response?.data?.settingsmsconfiguration);
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  useEffect(() => {
    transitionData();
  }, [listSamStoreID]);

  const hangleCancel = () => {
    setRowData({});
    setIds(null);
    setUname("");
    setPassword("");
    setSender("");
    setUrl("");
    setTempid("");
    setRoute("");
    setMsgtype("");
    setActive("");
    setSms("");
    handleClose();
  };

  const submitSMS = () => {
    const fd = new FormData();
    fd.append("store_id", selectStoreId);
    fd.append("uname", uname);
    fd.append("url", url);
    fd.append("password", password);
    fd.append("sender", sender);
    fd.append("tempid", tempid);
    fd.append("route", route);
    fd.append("msgtype", msgtype);
    fd.append("active_status", active);
    fd.append("sms", sms);
    axiosInstance
      .post(`api/admin/sms-configuration-store/?store_id=${storeId}`, fd, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        console.log("custom nitification Data list===>", response);
        toast.success(response?.data?.message);
        handleClose();
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  // const storeList = () => {
  //   axios
  //     .post(
  //       `https://app1.crazzyhub.com/api/multivendor-show-store-list/`,
  //       {
  //         page: 1,
  //         search_values: "",
  //       },
  //       {
  //         headers: {
  //           Token: localStorage.getItem("Token"),
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       setStoreData(response?.data?.data);
  //       console.log("store data list==>", response?.data);
  //     })
  //     .catch((error) => {
  //       console.log("", error.response);
  //       console.log(error);
  //       toast.error(error.message);
  //     });
  // };

  // useEffect(() => {
  //   storeList();
  // }, []);

  const editFunctionality = (event, row) => {
    event.preventDefault();
    console.log("row data====>", row);
    handleOpen();
    setIds(row?.id);
    setUname(row?.uname);
    setPassword(row?.password);
    setSender(row?.sender);
    setUrl(row?.url);
    setTempid(row?.tempid);
    setRoute(row?.route);
    setMsgtype(row?.msgtype);
    setSms(row?.sms);
    setActive(row?.active_status ? "True" : "False");
    setRowData(row);
  };

  return (
    <div className=" !bg-slate-100">
      <div className="flex justify-between">
        <div className="p-2">
          <p className="text-xl !text-black font font-bold">
            SMS Configuration
          </p>
        </div>
        <div className="p-2 pt-5">
          <Button variant="outlined" size="small" onClick={handleOpen}>
            Add New SMS
          </Button>{" "}
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
          >
            <Box
              sx={{ ...style, width: 890 }}
              className="rounded-2xl !border-0"
            >
              <div
                id="child-modal-title "
                className="!text-black !underline !font-bold !py-3 !text-center !text-xl"
              >
                {ids === null ? "Add NEW SMS" : "UPDATE SMS"}
              </div>
              {superuserId === "true" ? (
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    select Store
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Age"
                    size="small"
                    className="mt-3"
                    value={selectStoreId || rowData?.store?.id || ""}
                    onChange={(event) => setSelectStoreId(event.target.value)}
                  >
                    {storeData?.map((item) => (
                      <MenuItem value={item?.id}>{item?.store_name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ) : null}

              <div className="w-full flex justify-between">
                <div className="w-[48%]">
                  <div className="">User Name</div>
                  <TextField
                    size="small"
                    id="outlined-basic"
                    placeholder="Enter User Name"
                    className="!w-[100%] !mt-1"
                    name="uname"
                    value={uname}
                    onChange={(event) => setUname(event.target.value)}
                  />
                  <div className="mt-2">URL</div>
                  <TextField
                    size="small"
                    id="outlined-basic"
                    placeholder="Enter URL"
                    className="!w-[100%] !mt-1"
                    name="url"
                    value={url}
                    onChange={(event) => setUrl(event.target.value)}
                  />
                  <div className="mt-2">Temp Id</div>
                  <TextField
                    size="small"
                    id="outlined-basic"
                    placeholder="Enter Temp Id"
                    className="!w-[100%] !mt-1"
                    name="tempid"
                    value={tempid}
                    onChange={(event) => setTempid(event.target.value)}
                  />
                  <div className="mt-2">Route</div>
                  <TextField
                    size="small"
                    id="outlined-basic"
                    className="!w-[100%] !mt-1"
                    placeholder="Enter Route"
                    name="route"
                    value={route}
                    onChange={(event) => setRoute(event.target.value)}
                  />
                </div>
                <div className="w-[48%]">
                  <div>Password</div>
                  <TextField
                    size="small"
                    id="outlined-basic"
                    placeholder="Enter password"
                    className="!w-[100%] !mt-1"
                    name="product_name"
                    value={password}
                    onChange={(event) => setPassword(event.target.value)}
                  />

                  {/* <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Active Status
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Age"
                      size="small"
                      className="mt-3"
                      value={"" || active}
                      onChange={(event) => setActive(event.target.value)}
                    >
                      <MenuItem value={"True"}>True</MenuItem>
                      <MenuItem value={"False"}>False</MenuItem>
                    </Select>
                  </FormControl> */}
                  <div className="mt-2"> Active Status</div>
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={"" || active}
                      onChange={(event) => setActive(event.target.value)}
                    >
                      <FormControlLabel
                        value="True"
                        control={<Radio color="success" />}
                        label="True"
                      />
                      <FormControlLabel
                        value="False"
                        control={<Radio color="success" />}
                        label="False"
                      />
                    </RadioGroup>
                  </FormControl>
                  <div className="mt-2">Sender</div>
                  <TextField
                    size="small"
                    id="outlined-basic"
                    className="!w-[100%] !mt-1"
                    name="sender"
                    placeholder="Enter sender"
                    value={sender}
                    onChange={(event) => setSender(event.target.value)}
                  />
                  <div className="mt-2">MSM Type</div>
                  <TextField
                    size="small"
                    id="outlined-basic"
                    className="!w-[100%] !mt-1"
                    name="smsType"
                    placeholder="Enter MSM Type"
                    value={msgtype}
                    onChange={(event) => setMsgtype(event.target.value)}
                  />
                </div>
              </div>
              <div>
                <div className="mt-2">Sms</div>
                <textarea
                  placeholder="Enter Sms"
                  value={sms}
                  onChange={(event) => setSms(event.target.value)}
                  className="border border-gray-500 w-full mt-1 rounded-sm p-2"
                  rows={"2"}
                />
              </div>
              <Button
                onClick={hangleCancel}
                variant="contained"
                color="warning"
                className="!py-2 !mt-3"
              >
                CANCEL
              </Button>
              <Button
                variant="contained"
                type="submit"
                color="success"
                className="!py-2 !px-5 !font-bold !mt-3 !float-right"
                onClick={submitSMS}
              >
                {ids === null ? "ADD" : "UPDATE"}
              </Button>
            </Box>
          </Modal>
        </div>
      </div>
      <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
        <div className="flex justify-between mb-2">
          <div></div>
          <div className="flex mx-3 justify-between">
            <div className="">
              {/* <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  select Store
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Age"
                  size="small"
                  className="mt-3 !w-72"
                  onChange={(event) => setListSamStoreID(event.target.value)}
                >
                  {storeData?.map((item) => (
                    <MenuItem value={item?.id}>{item?.store_name}</MenuItem>
                  ))}
                </Select>
              </FormControl> */}
            </div>
          </div>
        </div>
        <TableContainer
          component={Paper}
          // sx={{  }}
          sx={{ width: "100%", maxHeight: 440 }}
          className="!text-black !mx-auto !bg-white overflow-auto px-2"
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ID
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-24">USER NAE</div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  PASSWORD
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-36">SENDOR </div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-40">route </div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-40">url</div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-52">msgtype</div>
                </TableCell>
                <TableCell
                  style={{
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ACTION
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="!bg-red">
              <TableRow className="!text-slate-700">
                <TableCell
                  className="!text-center !text-[12px]"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  {data.id ? data.id : "--"}
                </TableCell>
                <TableCell
                  className="!text-center !text-[12px]"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  {data?.uname ? data?.uname : "--"}
                </TableCell>
                <TableCell
                  className="!text-center !text-[12px]"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  {data?.password ? data?.password : "--"}
                </TableCell>
                <TableCell
                  className="!text-center !text-[12px]"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  {data?.sender ? data?.sender : "--"}
                </TableCell>

                <TableCell
                  className="!text-center !text-[12px]"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  {data?.route ? data?.route : "--"}
                </TableCell>
                <TableCell
                  className="!text-center !text-[12px]"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  {/* url */}
                  {data?.url ? data?.url : "--"}
                </TableCell>
                <TableCell
                  className="!text-center !text-[12px]"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  {data?.msgtype ? data?.msgtype : "--"}
                </TableCell>
                <TableCell
                  className="!text-center !text-[12px]"
                  style={{
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  <BorderColorIcon
                    className="text-green-500"
                    onClick={(event) => editFunctionality(event, data)}
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <div
          className="!float-right relative bg-white w-[100%] mx-auto bottom-0 right-0 py-3 border-t-2 border-gray-400 !flex-col !justify-end !items-center"
          style={{ marginRight: "0px" }}
        >
          <button className="!float-right">
            <ArrowForwardIosIcon />
          </button>
          <button className="float-right">
            <ArrowBackIosIcon />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SmsConfiguration;
